export default {
  cancel: 'Annuler',
  confirm: 'Confirmer',
};
